import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SubTreeNavigationComponent } from './sub-tree-navigation/sub-tree-navigation.component';
import { NavEntry } from './nav-entry';

@Component({
  standalone: false,
  selector: 'app-au-tree-navigation',
  templateUrl: './tree-navigation.component.html',
  styles: [':host { display: block}'],
})
export class TreeNavigationComponent implements AfterViewInit {

  @Input() navigation: NavEntry[] = [];
  @Input() autoExpand = true;

  @Input() innerClass: string | undefined;
  @Input() innerStyle: string | undefined;

  @ViewChild(SubTreeNavigationComponent) tree: SubTreeNavigationComponent | undefined;

  route!: string;
  fragment!: string;

  constructor(router: Router) {
    this.getRoute(router.url);
    
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.getRoute(event.url);
        if (this.autoExpand) {
          this.expandNav(this.route, this.fragment);
        }
      }
    })
  }

  ngAfterViewInit(): void {
    if (this.autoExpand) {
      this.expandNav(this.route, this.fragment);
    }
  }

  private getRoute(url: string) {
    const split = url.split('#');
    this.route = split[0];
    this.fragment = split.length > 1 ? split[1] : '';
  }

  public expandNav(route: string, fragment: string | null = null) {
    if (!route) return;
    if (!this.tree) return;
    this.tree.routeLinks.forEach(routeLink => {
      if (routeLink.name === route + fragment) {
        this.makeActive(routeLink);
        this.expandParentList(routeLink);
      }
    });
  }

  private expandParentList(item: Element) {
    const parent = item.closest('ul[au-sub-tree-navigation]');
    if (parent && parent.previousElementSibling && parent.parentElement) {
      this.makeActive(parent.previousElementSibling);
      this.makeActive(parent);
      this.expandParentList(parent.parentElement);
    }
  }

  private makeActive(item: Element) {
    if (!item) return;
    if (!item.classList.contains('em-is-active')) {
      item.classList.add('em-is-active');
    }
  }

}
